import { call, put, select, takeEvery, takeLatest } from 'redux-saga/effects';

import * as types from './constants';
import * as actions from './actions';
import { handleErrors, fetch } from '../../../api';
import api from '../../../api/endpoints';

// `type` is the creator route the notes hang off: 'public', 'custom' or 'chat' (same as the Creator page's type)
const notesApi = type => api.creator_object.notes[type];

const preparePage = data => ({
  results: data.results,
  count: data.count,
  next: data.next
});

function* getCreatorNotes({ payload: { type, id, signal } }) {
  try {
    const { data } = yield call(fetch, { api: notesApi(type).list, id, signal });

    yield put(actions.getCreatorNotesDone(preparePage(data)));
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.getCreatorNotesFailed,
      endpoint: notesApi(type).list.url
    });
  }
}

// The next page is loaded from the response's ready-made `next` URL
function* loadMoreCreatorNotes({ payload: { type, signal } }) {
  try {
    const next = yield select(state => state.creatorNotes.next);
    const { data } = yield call(fetch, { api: notesApi(type).list, url: next, signal });

    yield put(actions.loadMoreCreatorNotesDone(preparePage(data)));
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.loadMoreCreatorNotesFailed,
      endpoint: notesApi(type).list.url
    });
  }
}

function* createCreatorNote({ payload: { type, id, values, onSuccess, onError, handledErrors } }) {
  try {
    const { data } = yield call(fetch, { api: notesApi(type).create, id, data: values });

    onSuccess && onSuccess(data.result);
    yield put(actions.createCreatorNoteDone(data.result));
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.createCreatorNoteFailed,
      onError,
      handledErrors,
      endpoint: notesApi(type).create.url
    });
  }
}

function* updateCreatorNote({ payload: { type, id, noteId, values, onSuccess, onError, handledErrors } }) {
  try {
    const { data } = yield call(fetch, { api: notesApi(type).update, pathParams: { id, noteId }, data: values });

    onSuccess && onSuccess(data.result);
    yield put(actions.updateCreatorNoteDone(data.result));
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.updateCreatorNoteFailed,
      onError,
      handledErrors,
      endpoint: notesApi(type).update.url
    });
  }
}

function* removeCreatorNote({ payload: { type, id, noteId, onSuccess, onError } }) {
  try {
    yield call(fetch, { api: notesApi(type).remove, pathParams: { id, noteId } });

    onSuccess && onSuccess();
    yield put(actions.removeCreatorNoteDone(noteId));
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.removeCreatorNoteFailed,
      onError,
      endpoint: notesApi(type).remove.url
    });
  }
}

export const getCreatorNotesSaga = takeLatest(types.GET_CREATOR_NOTES_REQUEST, getCreatorNotes);
export const loadMoreCreatorNotesSaga = takeLatest(types.LOAD_MORE_CREATOR_NOTES_REQUEST, loadMoreCreatorNotes);
export const createCreatorNoteSaga = takeEvery(types.CREATE_CREATOR_NOTE_REQUEST, createCreatorNote);
export const updateCreatorNoteSaga = takeEvery(types.UPDATE_CREATOR_NOTE_REQUEST, updateCreatorNote);
export const removeCreatorNoteSaga = takeEvery(types.REMOVE_CREATOR_NOTE_REQUEST, removeCreatorNote);
